import { Heading as BaseHeading } from '@dutchie/backoffice-ui-library';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { down } from 'styled-breakpoints';

const IMAGE_SIZE = 32;

const flexColumnStyles = (arg?: { gap?: string }) => css`
  display: flex;
  flex-direction: column;
  gap: ${arg?.gap ?? 0};
`;

export const Page = styled.div<{ gap?: string }>`
  ${({ gap }) => flexColumnStyles({ gap: gap ?? 'var(--sizes-50)' })}
  align-items: center;
  height: 100%;
  width: 100%;
  background: var(--color-brand-primary-white);
  padding: var(--sizes-70) var(--sizes-100);
  display: flex;
  flex-direction: column;
  min-height: 0; /* Enable flex child shrinking */

  ${down('smallDesktop')} {
    height: auto;
    min-height: 100%;
  }
`;

export const Heading = styled(BaseHeading)`
  margin-bottom: 0;
  width: 100%;
`;

export const GridAndSearchContainer = styled.div<{
  $responsiveHeight?: boolean;
}>`
  ${flexColumnStyles()}
  align-items: center;
  width: 100%;
  flex: 1;
  min-height: 0; /* Enable flex child shrinking */
  border: 1px solid var(--color-gray-20);
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  ${down('smallDesktop')} {
    ${({ $responsiveHeight }) =>
      $responsiveHeight &&
      css`
        height: 400px;
        flex: none;
      `}
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--sizes-40);
  border-bottom: 1px solid var(--color-gray-20);
  height: 64px;
  flex-shrink: 0; /* Prevent search container from shrinking */
`;

export const DataGridContainer = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0; /* Enable flex child shrinking */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  > div {
    flex: 1;
    height: 100%;
  }
`;

export const BrandNameAndImage = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sizes-40);
`;

export const BrandImage = styled.img`
  width: ${IMAGE_SIZE}px;
  height: ${IMAGE_SIZE}px;
  border-radius: 5.12px;
  object-fit: cover;
`;

export const BrandPlacholderImage = styled.div`
  width: ${IMAGE_SIZE}px;
  height: ${IMAGE_SIZE}px;
  border: 1px solid var(--color-gray-20);
  border-radius: 3px;
  ${flexColumnStyles({ gap: '10px' })}
  align-items: center;
  justify-content: center;
`;
